import { render, staticRenderFns } from "./water.vue?vue&type=template&id=6bd9a1ee&scoped=true&"
import script from "./water.vue?vue&type=script&lang=js&"
export * from "./water.vue?vue&type=script&lang=js&"
import style0 from "./water.vue?vue&type=style&index=0&lang=css&"
import style1 from "./water.vue?vue&type=style&index=1&id=6bd9a1ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9a1ee",
  null
  
)

export default component.exports